import React, { useState, useRef, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { useReactToPrint } from 'react-to-print';
import PageHeading from '../../common/Heading/PageHeading';
import { LeftGrid } from '../../Episode/Episode.Styled';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { ContentTitle } from '../../ui/styled';
import Box from '@mui/material/Box';
import BackIcon from '../../common/Back/BackIcon';
import { useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { CDCR_REPORT_URL, paginationSize, dateFormat } from '../../../constants';
import { getCdcrReportData } from '../services/cdcrApi';
import { commonQueryParams } from '../../../services/QueryParams/QueryParams';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';

const PrintCDCR = () => {
  const STOP_REGION = process.env.REACT_APP_STOP_REGION
  const { state } = useLocation();
  const [user, setUser] = useState(null);
  const componentRef = useRef();
  const [reportData, setReportData] = useState({
    isLoading: false,
    data: [],
    //page: 1,
    //pageSize: 10,
    //sortModel: '',
    //filterModel: {items: []}
  });

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
      setReportData((old) => ({ ...old, isLoading: true }));
      const commonParams = commonQueryParams(
        CDCR_REPORT_URL + '?startDate=' + state.startDate,
        '',
        {}
      );
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      const data = await getCdcrReportData({
        commonParams,
        authorization,
      });
      console.log(data.data);
      setReportData((old) => ({
        ...old,
        ...data,
      }));
  };

  const inProgram = [
    {
    }
  ]

  return (
    <Box>
      <ContentTitle container>
      <Grid item xs={6}>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <BackIcon />
          <PageHeading title='CDCR Report' />
        </Box>
      </Grid>
      <LeftGrid item xs={6}>
        <Button
          variant='contained'
          style={{ justifyContent: 'flex-end' }}
          onClick={() => handlePrint()}
        >
          Print
        </Button>
      </LeftGrid>
      </ContentTitle>
      <Box pt={6} ref={componentRef}>
        {
          reportData.data.map((page, index) => {
            return (
              <div className="page-break" key={index}>
                <Box px={2}>
                  <Typography variant='h4' textAlign='center'>AFTER CARE</Typography>
                  <Typography variant='h4' textAlign='center'>PARTICIPANT COUNT - {page.gndID === 'M' ? 'MALES' : 'FEMALES'}</Typography>
                  <Typography variant='h5' textAlign='center'>FOR THE PERIOD OF {new moment(state.startDate).format(dateFormat)} THROUGH {moment(state.endDate).format(dateFormat)}</Typography>
                  <Typography variant='h5'>Area: {STOP_REGION}</Typography>
                  <Typography variant='h5'>Contractor: Westcare of California STOP Area {STOP_REGION === '1' ? 'I' : 'III'}</Typography>
                
                  <Typography variant='h4' pt={3}>PARTICIPANTS IN PROGRAM</Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="CDCR Aftercare">
                      <TableHead>
                        <TableRow>
                          <TableCell>Modality</TableCell>
                          <TableCell align="center">SAP Participants</TableCell>
                          <TableCell align="center">General Population Parolees</TableCell>
                          <TableCell align="center">Total</TableCell>                          
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Residential
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_RES}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES + page.poP_SAS_NONSAP_RES}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Non-Residential
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_Non + page.poP_SAS_NONSAP_Non}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Sober Living
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_SLE}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_SLE}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_SLE + page.poP_SAS_NONSAP_SLE}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: '#D3D3D3' }}
                          >
                            <TableCell component="th" scope="row">
                              Total
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES + page.poP_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_RES + page.poP_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES + page.poP_SAS_SAP_Non + page.poP_SAS_NONSAP_RES + page.poP_SAS_NONSAP_Non}</TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Typography variant='h4' pt={3}>PARTICIPANTS PLACED</Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Modality</TableCell>
                          <TableCell align="center">SAP Participants</TableCell>
                          <TableCell align="center">General Population Parolees</TableCell>
                          <TableCell align="center">Total</TableCell>                          
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Residential
                            </TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_RES}</TableCell>
                            <TableCell align="center">{page.adM_SAS_NONSAP_RES}</TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_RES + page.adM_SAS_NONSAP_RES}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Non-Residential
                            </TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.adM_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_Non + page.adM_SAS_NONSAP_Non}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Sober Living
                            </TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_SLE}</TableCell>
                            <TableCell align="center">{page.adM_SAS_NONSAP_SLE}</TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_SLE + page.adM_SAS_NONSAP_SLE}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: '#D3D3D3' }}
                          >
                            <TableCell component="th" scope="row">
                              Total
                            </TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_RES + page.adM_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.adM_SAS_NONSAP_RES + page.adM_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.adM_SAS_SAP_RES + page.adM_SAS_SAP_Non + page.adM_SAS_NONSAP_RES + page.adM_SAS_NONSAP_Non }</TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Typography variant='h4' pt={3}>PARTICIPANTS DISCHARGED</Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Modality</TableCell>
                          <TableCell align="center">SAP Participants</TableCell>
                          <TableCell align="center">General Population Parolees</TableCell>
                          <TableCell align="center">Total</TableCell>                          
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Residential
                            </TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_RES}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_NONSAP_RES}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_RES + page.dcH_SAS_NONSAP_RES}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Non-Residential
                            </TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_Non + page.dcH_SAS_NONSAP_Non}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Sober Living
                            </TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_SLE}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_NONSAP_SLE}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_SLE + page.dcH_SAS_NONSAP_SLE}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: '#D3D3D3' }}
                          >
                            <TableCell component="th" scope="row">
                              Total
                            </TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_RES + page.dcH_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_NONSAP_RES + page.dcH_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.dcH_SAS_SAP_RES + page.dcH_SAS_SAP_Non + page.dcH_SAS_NONSAP_RES + page.dcH_SAS_NONSAP_Non}</TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Typography variant='h4' pt={3}>PARTICIPANTS IN AFTERCARE</Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Modality</TableCell>
                          <TableCell align="center">SAP Participants</TableCell>
                          <TableCell align="center">General Population Parolees</TableCell>
                          <TableCell align="center">Total</TableCell>                          
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Residential
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES+page.adM_SAS_SAP_RES-page.dcH_SAS_SAP_RES}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_RES+page.adM_SAS_NONSAP_RES-page.dcH_SAS_NONSAP_RES}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES+page.adM_SAS_SAP_RES-page.dcH_SAS_SAP_RES+page.poP_SAS_NONSAP_RES+page.adM_SAS_NONSAP_RES-page.dcH_SAS_NONSAP_RES}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Non-Residential
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_Non+page.adM_SAS_SAP_Non-page.dcH_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_Non+page.adM_SAS_NONSAP_Non-page.dcH_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_Non+page.adM_SAS_SAP_Non-page.dcH_SAS_SAP_Non+page.poP_SAS_NONSAP_Non+page.adM_SAS_NONSAP_Non-page.dcH_SAS_NONSAP_Non}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              Sober Living
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_SLE+page.adM_SAS_SAP_SLE-page.dcH_SAS_SAP_SLE}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_SLE+page.adM_SAS_NONSAP_SLE-page.dcH_SAS_NONSAP_SLE}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_SLE+page.adM_SAS_SAP_SLE-page.dcH_SAS_SAP_SLE+page.poP_SAS_NONSAP_SLE+page.adM_SAS_NONSAP_SLE-page.dcH_SAS_NONSAP_SLE}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: '#D3D3D3' }}
                          >
                            <TableCell component="th" scope="row">
                              Total
                            </TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES+page.adM_SAS_SAP_RES-page.dcH_SAS_SAP_RES + page.poP_SAS_SAP_Non+page.adM_SAS_SAP_Non-page.dcH_SAS_SAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_NONSAP_RES+page.adM_SAS_NONSAP_RES-page.dcH_SAS_NONSAP_RES + page.poP_SAS_NONSAP_Non+page.adM_SAS_NONSAP_Non-page.dcH_SAS_NONSAP_Non}</TableCell>
                            <TableCell align="center">{page.poP_SAS_SAP_RES+page.adM_SAS_SAP_RES-page.dcH_SAS_SAP_RES + page.poP_SAS_SAP_Non+page.adM_SAS_SAP_Non-page.dcH_SAS_SAP_Non + page.poP_SAS_NONSAP_RES+page.adM_SAS_NONSAP_RES-page.dcH_SAS_NONSAP_RES + page.poP_SAS_NONSAP_Non+page.adM_SAS_NONSAP_Non-page.dcH_SAS_NONSAP_Non}</TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </div>  
            )    
          })
        }
      </Box>  
    </Box>


  );
};

export default PrintCDCR